import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import { Activity } from "@mapmycustomers/shared/types/entity";

import EntityViewPayload from "@app/store/entityView/EntityViewPayload";
import { RootState } from "@app/store/rootReducer";
import HideAction from "@app/types/HideCallback";

import EditActivityModal, {
  mapDispatchToPropsEditActivityModal,
  mapStateToPropsEditActivityModal,
} from "../../createEditEntity/Activity/EditActivityModal";

import {
  ActivityAnnotation,
  mapDispatchToPropsActivityAnnotation,
  mapStateToPropsActivityAnnotation,
} from "./index";

const mapStateToProps = (state: RootState) => {
  const { focusedFieldName, ...data } = mapStateToPropsEditActivityModal(state);
  return data;
};

const EditModal = connect(mapStateToProps, mapDispatchToPropsEditActivityModal)(EditActivityModal);

const { onEdit, ...mapDispatchToProps } = mapDispatchToPropsActivityAnnotation;

const Annotation = connect(
  mapStateToPropsActivityAnnotation,
  mapDispatchToProps
)(ActivityAnnotation);

interface Props {
  activityId: Activity["id"];
  allowSendViaEmailClient?: boolean;
  allowSendViaMmcEmail?: boolean;
  element?: HTMLElement;
  onChange?: (activity?: Activity) => void;
  onHide: (updated?: boolean) => void;
}

const AnnotationEditModal: React.FC<Props> = ({
  activityId,
  allowSendViaEmailClient,
  allowSendViaMmcEmail,
  element,
  onChange,
  onHide,
}) => {
  const [editModalPayload, setEditModalPayload] = useState<EntityViewPayload | undefined>();

  const handleHideEdit: HideAction<Activity> = useCallback(
    (updated, activity) => {
      if (updated) {
        onChange?.(activity);
      }

      onHide(updated);

      setEditModalPayload(undefined);
    },
    [onChange, onHide]
  );

  return editModalPayload ? (
    <EditModal
      activityId={activityId}
      onHide={handleHideEdit}
      overrideValues={editModalPayload.editValues as Partial<Activity>}
      requiredFieldsOnly={editModalPayload.requiredFieldsOnly}
    />
  ) : (
    <Annotation
      activityId={activityId}
      allowSendViaEmailClient={allowSendViaEmailClient}
      allowSendViaMmcEmail={allowSendViaMmcEmail}
      eventElement={element}
      onChange={onChange}
      onEdit={setEditModalPayload}
      onHide={onHide}
    />
  );
};

export default AnnotationEditModal;
